export const DELAY_RENDER_RETRIES = 3
